import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import CartDropdown from '../CartDropdown';
import leoraIcon from '../../assets/leoraIcon.png';
import './Header.css';

function Header() {
  const location = useLocation();
  const { totalItems } = useCart();
  const [cartOpen, setCartOpen] = useState(false);

  return (
    <header className="header">
      <div className="header-inner">
        <Link to="/" className="header-logo">
          <img src={leoraIcon} alt="Leora" className="header-logo-img" />
        </Link>

        <nav className="header-nav">
          <Link
            to="/"
            className={`header-link ${location.pathname === '/' ? 'active' : ''}`}
          >
            Inicio
          </Link>
          <Link
            to="/productos"
            className={`header-link ${location.pathname.startsWith('/productos') ? 'active' : ''}`}
          >
            Productos
          </Link>
        </nav>

        <div className="header-cart-wrapper">
          <button
            className="header-cart-btn"
            onClick={() => setCartOpen((o) => !o)}
            aria-label="Carrito de compras"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" />
              <line x1="3" y1="6" x2="21" y2="6" />
              <path d="M16 10a4 4 0 01-8 0" />
            </svg>
            {totalItems > 0 && (
              <span className="header-cart-badge">{totalItems}</span>
            )}
          </button>
          <CartDropdown isOpen={cartOpen} onClose={() => setCartOpen(false)} />
        </div>
      </div>
    </header>
  );
}

export default Header;
